$(document).ready(function(){

  $(".dtpropg .title-row h2").attr("aria-level", "1");
  $(".dtpropg .product-description h1").attr("aria-level", "2");
  $(".drheaditxt h1").attr("aria-level", "2");
  $(".breadcrumbs a[href='/products/dt-pro-presale'].breadcrumbs-list__link").attr("aria-label", "current page, DT PRO");
  $(".vendorlinks a").attr("aria-label", "Draft Top");


$(".section-rich-text .article h4").attr("aria-level", "2");
$(".filclps").click(function(){
    $(this).attr('aria-expanded', function(i, attr) {
        return attr == 'true' ? 'false' : 'true'
      });
});
// $('div.slick-slide[role]').removeAttr('role');
  
$(".ourstorytitle h2").attr("aria-level", "1");
$(".togglesection button.togglebtn").attr("aria-expanded", "false");
$(".togglercntn").hide();
$(".togglebtn").click(function(){
    $(this).toggleClass("is-oopen");
       
    if ($(this).parent().children(".togglercntn").is(':visible')){
    $(this).parent().children(".togglercntn").slideUp();
    }else{
    $(".togglercntn").slideUp();
    $(this).parent().children(".togglercntn").slideDown();
    }
    $(this).attr('aria-expanded', function(i, attr) {
          return attr == 'true' ? 'false' : 'true'
        });
    });
var newDiv = jQuery('<span></span>').prependTo('button.upcart-product-quantity-minus');

// Add a class to the prepended div
newDiv.addClass('visually-hidden visually-hidden--inline');
newDiv.text('Decrease quantity');
  var newDiv = jQuery('<span></span>').prependTo('button.upcart-product-quantity-plus');

// Add a class to the prepended div
newDiv.addClass('visually-hidden visually-hidden--inline');
newDiv.text('Increase quantity');
  $("input.upcart-product-quantity-input").attr("aria-label", "Quantity Stepper");
  
$('a[href="mailto:HelloKick@DraftTop.com"]').attr('aria-label', 'Email Address:Hellokick@drafttop.com');
$('a[href="mailto:hello@DraftTop.com"]').attr('aria-label','Email Address: hello@DraftTop.com');
$('a[href="https://oag.ca.gov/privacy/ccpa"]').attr('aria-label','Learn more about CCPA and your privacy rights, this link opens in new tab you will Leave from this website and go to oag.ca.gov');
$('a[href="http://www.allaboutcookies.org"]').attr('aria-label','http://www.allaboutcookies.org, this link opens in a new tab ');
$('a[href="https://www.shopify.com/legal/privacy"]').attr('aria-label','https://www.shopify.com/legal/privacy, this link will open in a new tab');
$('a[href="https://tools.google.com/dlpage/gaoptout"]').attr('aria-label','https://tools.google.com/dlpage/gaoptout, this link will open in a new tab');
$('a[href="https://www.facebook.com/settings/?tab=ads"]').attr('aria-label','https://www.facebook.com/settings/?tab=ads, this link will open in a new tab');
$('a[href="https://www.google.com/settings/ads/anonymous"]').attr('aria-label','https://www.google.com/settings/ads/anonymous, this link will open in a new tab');
$('a[href="https://advertise.bingads.microsoft.com/en-us/resources/policies/personalized-ad"]').attr('aria-label','https://advertise.bingads.microsoft.com/en-us/resources/policies/personalized-ad, this link will open in a new tab');
$('a[href="https://www.google.com/intl/en/policies/privacy/"]').attr('aria-label','https://www.google.com/intl/en/policies/privacy/, this link will open in a new tab');

var newDiv = jQuery('<div></div>').prependTo('.gallery__item-1 div.gallery__image');
// Add a class to the prepended div
newDiv.addClass('background-overlay');

$('.gallery__item-1 div.gallery__image .background-overlay').attr('aria-label', 'DT Lift with open can with sports case in background');
$('.gallery__item-1 div.gallery__image .background-overlay').attr('role', 'img');
var newDiv = jQuery('<div></div>').prependTo('.gallery__item-2 div.gallery__image');
// Add a class to the prepended div
newDiv.addClass('background-overlay');

$('.gallery__item-2 div.gallery__image .background-overlay').attr('aria-label', 'DT Lift with open can and pasta dish');
$('.gallery__item-2 div.gallery__image .background-overlay').attr('role', 'img');
var newDiv = jQuery('<div></div>').prependTo('.gallery__item-3 div.gallery__image');
// Add a class to the prepended div
newDiv.addClass('background-overlay');

$('.gallery__item-3 div.gallery__image .background-overlay').attr('aria-label', 'Hand squeezing lime juice into a topless can');
$('.gallery__item-3 div.gallery__image .background-overlay').attr('role', 'img');
var newDiv = jQuery('<div></div>').prependTo('.gallery__item-4 div.gallery__image');
// Add a class to the prepended div
newDiv.addClass('background-overlay');

$('.gallery__item-4 div.gallery__image .background-overlay').attr('aria-label', 'DT Lift, opened can with Ski equipment');
$('.gallery__item-4 div.gallery__image .background-overlay').attr('role', 'img');
$('div.product-description.cf h3').attr('aria-level', '2');
$('div.shopify-policy__body h2:has(strong:not(:parent))').remove();
// $('.section-featured-product div.slide--custom-initial').attr('aria-label','Drafttop products');
// $('.gallery--layout-carousel-under div.slide--custom-initial').attr('aria-label','Drafttop products');
$('div.container--no-max .utility-bar__left a').attr('aria-label','Filter');
$('.video-container--image .overlay-text__text a.video-container__play').attr('aria-label','Play Drafttop video');
$('div.cloned').removeAttr('aria-hidden');
$('div#shopify-section-header').attr('role','banner');
$('#shopify-section-template--14808967807110__16359278867b92de38 div.column--half a.block-link').attr('aria-label','Halford hard cinger beer collections');
$('#shopify-section-template--14808968003718__0b0084bb-bf88-46b5-bce0-9b4620333bb1 div.column--half a.block-link').attr('aria-label','DT Pro outside on a picnic table with various open cans showing different prepared drinks, this link opens in new tab you will be departed from this website and go to kickstarter.com');
$('#shopify-section-template--14808968003718__0b0084bb-bf88-46b5-bce0-9b4620333bb1 div.lightly-spaced-row-above a.btn--primary').attr('aria-label','Pre order now Drafttop drink topless, this link opens in new tab you will be departed from this website and go to kickstarter.com');
$('#shopify-section-template--14808968003718__b8598640-d235-418a-a7ce-a3089868e9b5 div.lightly-spaced-row-above a.btn--primary').attr('aria-label','Pre order now Drafttop drink topless, this link opens in new tab you will be departed from this website and go to indiegogo.com');
$('#shopify-section-template--14808968003718__b8598640-d235-418a-a7ce-a3089868e9b5 div.column--half a.block-link').attr('aria-label','DT Pro on bar counter and being used in a bar, this link opens in new tab you will be departed from this website and go to indiegogo.com');
$('div.view-all a.small-feature-link').attr('aria-label','View all collections');
  
$('.input-row button.button--large').on('click', function() {
    setTimeout(function() {
        var $modal = $('div#CartPopup');
        if($modal.length) {
            $modal.attr('tabindex', '-1').focus();
        }
    }, 2000); 
});

  $('.utility-bar__left a.utility-bar__item').on('click', function() {
    // $(this).find('.filter-container--show-filters-desktop').toggleClass('filter-container--show-filters-mobile');
    var isExpanded = $(this).attr('aria-expanded') === 'true';
    $(this).attr('aria-expanded', !isExpanded);
  });

  // $('.filt-colse').click(function(){
  //  $(this).find('.filter-container--show-filters-mobilr').toggleClass('filter-container--show-filters-desktop')
  // });

$('div#CartPopup').attr('tabindex','0');
$('div.togglesection div.togglercntn br').attr('aria-hidden', 'true');
  $('#template--14808967807110__1635928580d75f81bf-6780737454214-color-selector-opt-0').prop('checked', true); 
});
$(document).ready(function() {
    $('#in-context-paypal-metadata')
        .attr('name', 'paypal-metadata') // Add name attribute
        .attr('content', 'PayPal payment metadata for processing transactions.') // Add content attribute
        .attr('http-equiv', 'some-value'); // Add http-equiv if needed
});

$(document).ready(function () {
  // Example: target anchors whose text is exactly "here"
  $('a').filter(function () {
    return $(this).text().trim().toLowerCase() === 'here';
  }).each(function () {
    var href = $(this).attr('href') || '';

    // Customize based on destination
    if (href.includes('privacy-policy')) {
      $(this).attr('aria-label', 'Read our Privacy Policy');
    } else if (href.includes('terms')) {
      $(this).attr('aria-label', 'Read our Terms and Conditions');
    } else {
      // Fallback: announce destination URL
      $(this).attr('aria-label', 'Visit ' + href);
    }
  });
});
